export const CHANGE_CLIENT_HEADER = 'LAYOUT:CHANGE_CLIENT_HEADER';
export const CHANGE_PROJECT_HEADER = 'LAYOUT:CHANGE_PROJECT_HEADER';
export const CHANGE_TEAM_HEADER = 'LAYOUT:CHANGE_TEAM_HEADER';
export const CHANGE_COMPANY_HEADER = 'LAYOUT:CHANGE_COMPANY_HEADER';
export const CHANGE_SSO_SCHEMA_HEADER = 'LAYOUT:CHANGE_SSO_SCHEMA_HEADER';
export const RESET_ALL_HEADERS = 'LAYOUT:RESET_ALL_HEADERS';
